<template>
    <div>
        <compWrapper title="供应商信息" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">保存</vButton>
				<vButton class="margin-right-20" @click="cancel">取消</vButton>
			</template>
        </compWrapper>
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <!-- 弹框 -->
		<compModal @on-close="operate.show=false" v-bind="operate" v-model="operate.show">
			<component
				:is="operate.component"
				@on-close="operate.show=false"
				v-bind="operate.props"
				v-if="operate.component"
				v-on="operate.on"
			/>
		</compModal>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetWarehouseSkuOne,HttpSaveWarehouseSkuOne } from "@/service/products/channel";
import { HttpSysOpLog } from '@/service/boss/allot';
import { mapState,mapGetters } from "vuex";
import compErpsku from '../../purchase/supplierproduct/update/erpsku'
export default {
    props:['activeid','querytype'],
    components:{
        compErpsku
    },
    data(){
        return {
            id: this.$route.query.id || this.activeid,
            type: this.$route.params.type || this.querytype,
            operate: {
				show: false,
			},
            formData:{
                productId:''
            },
            loading:false,
        }
    },
    created(){
        this.getDetail()
    },
    computed:{
        ...mapGetters('diction',['getNewProductList','getNewWarehouseIdList']),
        getBase(){
            return [
                {
					label: "ERPSKU",
                    key: "erpsku",
                    children: (h) => {
						return <vIcon
							type='search'
							slot='suffix'
							size='18'
							class='margin-right-5'
							nativeOnClick={this.handleUserModal}
						/>
                    },
                    props: {
						readonly: true
					}
                    
				},
                {
					label: "项目",
                    key:'lineId',
                    tag: "vSelect",
                    options: this.getNewProductList,
                    query:true
                },
                {
					label: "仓库",
                    key: "orgWarehouseId",
					tag: "vSelect",
                    options: this.getNewWarehouseIdList,
				},
                {
					label: "仓库SKU",
                    key:'orgWarehouseSku',
					tag: "vInput",
                },
            ]
        },
    },
    methods:{
        getDetail(){
            if(this.type=='add') return
            HttpGetWarehouseSkuOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            // 请求操作历史
            HttpSysOpLog({
                search: {
                    EQ_opDataId: this.id,
                    EQ_opModel: 'Org_Warehouse_Sku'
                }
            }).then(res => {
                // console.log(res.data)
                this.logList = res.data.content
            }, err => {

            })
        },
        //查询ERPSKU
		handleUserModal() {
			this.operate = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
					initFormData: {
						"search[EQ_lineId]": ''
					}
				},
				on: {
					'on-data': (data) => {
                        // console.log(data)
                        this.formData = {
                            productId: data.id,
							erpsku: data.erpSku,
							lineId: data.lineId,
						}
                        
                        this.operate = {};
                        
					}
				},
			}
		},
        submit(){

            let wareone = this.getNewWarehouseIdList.filter(item => { return item.value == this.formData.orgWarehouseId})[0] || {}


            let jsondata = {
                id:this.id,
                orgId:global.SYSID,
                productId:this.formData.productId,
                erpsku:this.formData.erpsku,
                lineId:this.formData.lineId,
                orgWarehouseSku:this.formData.orgWarehouseSku,
                orgWarehouseId:this.formData.orgWarehouseId,
                orgWarehouseCode:wareone.attach.item.code
            }
            this.loading = true;
            HttpSaveWarehouseSkuOne({
                id:this.id,
                ...jsondata,
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message)
                this.cancel()
            },err=>{
                this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'warehouseskuList',
            })
        }
    }
}
</script>

